import { Button, Dialog, MenuItem } from "@material-ui/core";
import styles from "./CustomerInfoDailogEdit.module.scss";
import Clear from "@material-ui/icons/Clear";
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { KeyboardArrowDown } from "@material-ui/icons";
import subNavStyles from "../../../../shared/subnav/subNavStyles";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import {
  BUSINESS,
  CONSUMER_TYPE,
  ORGANIZATION,
  ORGANIZATION_TYPE,
} from "../../../../common/Constants";
import { logMsg } from "../../../../common/Logger";
import DealerReportingClient from "../../../../shared/clients/DealerReportingClient";
import CustomerReservationsClient from "../../../../shared/clients/CustomerReservationsClient";
import UpperCaseText from "../../../../utils/UpperCaseText";

const StyledSelect = withStyles({
  select: {
    width: 200,
    borderRadius: 5,
    border: "solid 1px #d8d8d8",
    backgroundColor: "white",
    fontFamily: "FordAntenna-Regular, sans-serif",
    color: "#102b4e",
    fontSize: 14,
    lineHeight: 2.0,
    letterSpacing: 1,
    paddingLeft: 10,
    "&:focus": {
      background: "transparent",
    },
  },
})(Select);

const StyledMenuItem = withStyles({
  root: {
    fontFamily: "FordAntenna-Regular, sans-serif",
    fontSize: 14,
    lineHeight: 1.43,
    letterSpacing: 1,
    color: "#102b4e",
    padding: 10,
    margin: 0,
  },
})(MenuItem);
const StyledDialog = withStyles({
  paper: {
    width: 500,
    maxWidth: 500,
  },
})(Dialog);

class CustomerInfoDialogEdit extends Component {
  constructor(props) {
    super(props);
    this.initialState = {
      firstName: this.props.data.firstName,
      lastName: this.props.data.lastName,
      mobilePhoneNumber: this.props.data.mobilePhoneNumber,
      address1: this.props.data.address1,
      address2: this.props.data.address2,
      address3: this.props.data.address3,
      address4: this.props.data.address4,
      city: this.props.data.city,
      state: this.props.data.state,
      zip: this.props.data.zip,
      country: this.props.data.country,
      consumerType: this.props.data.consumerType,
      companyName: this.props.data.companyName,
    };
    this.state = this.initialState;
  }

  handleClose = () => {
    this.props.closeModal();
    this.setState(this.initialState);
  };

  handleUpdate = () => {
    const customerInfoObject = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      mobilePhoneNumber: this.state.mobilePhoneNumber,
      address1: this.state.address1,
      address2: this.state.address2,
      address3: this.state.address3,
      address4: this.state.address4,
      city: this.state.city,
      state: this.state.state,
      zip: this.state.zip,
      country: this.state.country,
    };

    const consumerType = this.state.consumerType;
    const companyName = this.state.companyName;

    if (consumerType.toUpperCase() === BUSINESS) {
      customerInfoObject["consumerType"] = ORGANIZATION_TYPE;
      customerInfoObject["companyName"] = companyName;
    } else {
      customerInfoObject["consumerType"] = consumerType;
      customerInfoObject["companyName"] = "";
    }

    this.props.hideOrShow(true);
    this.props.closeModal();
    CustomerReservationsClient.updateCustomerInfoToScac(
      this.props.user,
      customerInfoObject,
      this.props.data.userGuid
    )
      .then(() => {
        this.updateCustomerInfoOnMongoDb(
          this.props.user,
          customerInfoObject,
          this.props.data.userGuid
        );
        this.props.refreshOrderDetails();
      })
      .catch((error) => {
        logMsg("the error is: ", error);
        this.props.onError();
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  updateCustomerInfoOnMongoDb = (user, reqBody, guid) => {
    DealerReportingClient.updateOrderDetailsCustomerInfo(user, reqBody, guid)
      .then(() => {})
      .catch((error) => {
        logMsg("the error is: ", error);
        this.props.onError();
      })
      .finally(() => {});
  };

  isBusinessConsumerType = () =>
    UpperCaseText(this.state.consumerType) === BUSINESS;
  renderTextField = (label, value, fieldName, isRequired) => {
    let validators = [];
    if (isRequired === true) {
      validators = ["required"];
    }
    return (
      <>
        <div className={styles.textAreaTitle}>
          {label} {isRequired && <span className={styles.redText}>*</span>}{" "}
        </div>
        <div className={styles.textInputStyle}>
          <TextValidator
            variant="outlined"
            name={fieldName}
            value={value}
            validators={validators}
            errorMessages={[this.props.t("Error.requiredField")]}
            onChange={(e) => {
              this.setState({
                [fieldName]: e.target.value,
              });
            }}
            className={styles.inputField}
            data-testid="customerInfoEdit"
          />
        </div>
        {/*</div>*/}
      </>
    );
  };

  render() {
    return (
      <StyledDialog open={this.props.open}>
        <Grid container className={styles.wrapper}>
          <Grid item md={1}></Grid>
          <Grid item md={10}>
            <div className={styles.header}>
              {this.props.t("customerInfoEditDialog.editCustomerInfo")}
            </div>
            <ValidatorForm
              ref="form"
              className={styles.form}
              data-testid="customerInfoDialogEdit"
              onSubmit={this.handleUpdate}
            >
              <div id="consumerTypeDropdown" className={styles.dropdownDiv}>
                <FormControl id="menu">
                  <StyledSelect
                    name="typeOfConsumerDropdown"
                    id="selectTypeOfConsumerDropdown"
                    className={styles.dropdown}
                    IconComponent={() => (
                      <KeyboardArrowDown style={subNavStyles.icon} />
                    )}
                    value={
                      UpperCaseText(this.state.consumerType) === ORGANIZATION
                        ? "Business"
                        : this.state.consumerType
                    }
                    onChange={(event) => {
                      this.setState({ consumerType: event.target.value });
                    }}
                  >
                    {CONSUMER_TYPE.map((type) => {
                      return (
                        <StyledMenuItem
                          id={type}
                          data-testid={type}
                          key={type}
                          value={type}
                        >
                          {type}
                        </StyledMenuItem>
                      );
                    })}
                  </StyledSelect>
                </FormControl>
              </div>

              {this.isBusinessConsumerType() &&
                this.renderTextField(
                  this.props.t("customerInfoEditDialog.companyName"),
                  this.state.companyName,
                  "companyName",
                  true
                )}
              {this.renderTextField(
                this.props.t("customerInfoEditDialog.firstName"),
                this.state.firstName,
                "firstName",
                true
              )}

              {this.renderTextField(
                this.props.t("customerInfoEditDialog.lastName"),
                this.state.lastName,
                "lastName",
                true
              )}
              {this.renderTextField(
                this.props.t("customerInfoEditDialog.contactAddressLine1"),
                this.state.address1,
                "address1",
                true
              )}

              {this.renderTextField(
                this.props.t("customerInfoEditDialog.contactAddressLine2"),
                this.state.address2,
                "address2",
                false
              )}

              {this.renderTextField(
                this.props.t("customerInfoEditDialog.contactAddressLine3"),
                this.state.address3,
                "address3",
                false
              )}

              {this.renderTextField(
                this.props.t("customerInfoEditDialog.contactAddressLine4"),
                this.state.address4,
                "address4",
                false
              )}

              {this.renderTextField(
                this.props.t("customerInfoEditDialog.city"),
                this.state.city,
                "city",
                true
              )}

              {this.renderTextField(
                this.props.t("customerInfoEditDialog.state"),
                this.state.state,
                "state",
                false
              )}

              {this.renderTextField(
                this.props.t("customerInfoEditDialog.zip"),
                this.state.zip,
                "zip",
                true
              )}

              {this.renderTextField(
                this.props.t("customerInfoEditDialog.country"),
                this.state.country,
                "country",
                true
              )}

              {this.renderTextField(
                this.props.t("customerInfoEditDialog.phoneNumber"),
                this.state.phoneNumber,
                "phoneNumber",
                false
              )}

              {this.renderTextField(
                this.props.t("customerInfoEditDialog.mobilePhoneNumber"),
                this.state.mobilePhoneNumber,
                "mobilePhoneNumber",
                true
              )}

              <div className={styles.textAreaTitle}>
                <span className={styles.redText}>*</span>
                <span>
                  {" "}
                  {this.props.t("customerInfoEditDialog.mandatoryNote")}
                </span>
              </div>

              <Button type="submit" className={styles.actionBtn}>
                {this.props.t("customerInfoEditDialog.saveContactInformation")}
              </Button>
            </ValidatorForm>
          </Grid>
          <Grid item md={1}>
            <button className={styles.close} onClick={this.handleClose}>
              <Clear />
            </button>
          </Grid>
        </Grid>
      </StyledDialog>
    );
  }
}

export default withTranslation("emp")(CustomerInfoDialogEdit);
